import superagent from '@ott/superagent';

const prepareQuery = rawDeals => {
  const directions = rawDeals.result.map(group => ({
    id: group.searchQuery.object_id,
    type: group.searchQuery.object_type,
  }));

  return directions;
};

const DEFAULT_TIMEOUT = 158000;

const endpointUrl = '/_hotels/api/objects';

const getHapiGeo = async rawDeals => {
  const query = prepareQuery(rawDeals);

  const { body: response } = await superagent
    .post(endpointUrl)
    .send(query)
    .timeout(DEFAULT_TIMEOUT)
    .withCredentials();

  return response;
};

export default getHapiGeo;
